"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _utils = require("@alycecom/utils");

var _Close = _interopRequireDefault(require("@mui/icons-material/Close"));

var _ramda = require("ramda");

var _ui = require("@alycecom/ui");

var _SingleSelectedCountryOption = _interopRequireDefault(require("./SingleSelectedCountryOption"));

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette,
      spacing = _ref.spacing;
  return {
    flagIcon: {
      width: 18,
      height: 18
    },
    checkbox: {
      color: palette.primary.main,
      marginRight: spacing(1)
    },
    countryName: {
      marginLeft: spacing(1)
    },
    chipsContainer: {
      width: '100%',
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      flexWrap: 'wrap',
      '& > *': {
        margin: spacing(0, 0.25, 0.5)
      },
      marginTop: spacing(0.5)
    },
    chipRoot: {
      height: 28,
      backgroundColor: palette.green.mountainMeadowLight,
      color: palette.common.white,
      '&:focus': {
        backgroundColor: palette.green.mountainMeadowLight
      }
    },
    chipClickable: {
      backgroundColor: palette.green.mountainMeadowLight,
      color: palette.common.white
    },
    chipDeleteIcon: {
      color: palette.common.white,
      width: 16,
      height: 16,
      '&:hover': {
        color: palette.common.white
      }
    },
    chipLabel: {
      paddingTop: 2,
      maxWidth: 200
    },
    countryValueLabel: {
      color: palette.text.primary
    }
  };
});

var CountriesPicker = function CountriesPicker(_ref2) {
  var onChange = _ref2.onChange,
      options = _ref2.options,
      value = _ref2.value,
      multiple = _ref2.multiple,
      _ref2$showChips = _ref2.showChips,
      showChips = _ref2$showChips === void 0 ? false : _ref2$showChips,
      _ref2$visibleChipsCou = _ref2.visibleChipsCount,
      visibleChipsCount = _ref2$visibleChipsCou === void 0 ? 2 : _ref2$visibleChipsCou,
      disabled = _ref2.disabled,
      _ref2$selectAllEnable = _ref2.selectAllEnabled,
      selectAllEnabled = _ref2$selectAllEnable === void 0 ? false : _ref2$selectAllEnable,
      autoCompleteProps = (0, _objectWithoutProperties2.default)(_ref2, ["onChange", "options", "value", "multiple", "showChips", "visibleChipsCount", "disabled", "selectAllEnabled"]);
  var classes = useStyles();
  var name = autoCompleteProps.name,
      label = autoCompleteProps.label,
      externalClasses = autoCompleteProps.classes;
  var isAllSelected = value && options.length === value.length;
  var handleUnselectCountry = (0, _react.useCallback)(function (event) {
    var _event$currentTarget;

    var _event$currentTarget$ = event === null || event === void 0 ? void 0 : (_event$currentTarget = event.currentTarget) === null || _event$currentTarget === void 0 ? void 0 : _event$currentTarget.dataset,
        id = _event$currentTarget$.id;

    var numId = Number(id);

    if (Number.isNaN(numId) || !multiple) {
      return;
    }

    var countries = value.filter(function (country) {
      return country.id !== numId;
    });
    onChange(countries, name);
  }, [onChange, value, multiple, name]);
  var renderValue = (0, _react.useCallback)(function (renderedValues) {
    if (multiple && Array.isArray(renderedValues) && renderedValues.length === 1) {
      return /*#__PURE__*/_react.default.createElement(_SingleSelectedCountryOption.default, {
        classes: {
          label: externalClasses === null || externalClasses === void 0 ? void 0 : externalClasses.valueLabel
        },
        name: renderedValues[0].name,
        flag: renderedValues[0].image
      });
    }

    if (!multiple && renderedValues) {
      return /*#__PURE__*/_react.default.createElement(_SingleSelectedCountryOption.default, {
        classes: {
          label: externalClasses === null || externalClasses === void 0 ? void 0 : externalClasses.valueLabel
        },
        name: renderedValues.name,
        flag: renderedValues.image
      });
    }

    if (multiple && Array.isArray(renderedValues) && renderedValues.length > 1) {
      return /*#__PURE__*/_react.default.createElement(_material.Box, {
        className: externalClasses === null || externalClasses === void 0 ? void 0 : externalClasses.valueLabel,
        component: "span"
      }, "Countries (", renderedValues.length, ")");
    }

    return /*#__PURE__*/_react.default.createElement(_material.Box, {
      className: externalClasses === null || externalClasses === void 0 ? void 0 : externalClasses.valueLabel,
      component: "span"
    }, label);
  }, [multiple, label, externalClasses]);
  var getOptionLabel = (0, _react.useCallback)(function (country) {
    return country.name;
  }, []);
  var renderOption = (0, _react.useCallback)(function (props, option, _ref3) {
    var selected = _ref3.selected;
    var optionLabel = getOptionLabel(option);
    var optionLabelForId = (0, _utils.toUnderscore)(optionLabel);
    return /*#__PURE__*/_react.default.createElement("li", (0, _extends2.default)({}, props, {
      key: option.id
    }), /*#__PURE__*/_react.default.createElement(_material.Box, {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
      "data-testid": "AlyceUI.CountryPicker.Option.Checkbox.".concat(option.id)
    }, multiple && /*#__PURE__*/_react.default.createElement(_material.Checkbox, {
      className: classes.checkbox,
      checked: isAllSelected || selected,
      onChange: function onChange() {},
      color: "primary",
      "data-testid": "AlyceUI.CountryPicker.Option.Checkbox.".concat(optionLabelForId)
    }), option.image && (0, _utils.isValidImage)(option.image) && /*#__PURE__*/_react.default.createElement("img", {
      className: classes.flagIcon,
      src: option.image,
      alt: "".concat(option.name, " flag")
    }), /*#__PURE__*/_react.default.createElement(_material.Typography, {
      "data-testid": "AlyceUI.CountryPicker.Option.Label.".concat(optionLabelForId),
      className: classes.countryName
    }, option.name)));
  }, [classes, getOptionLabel, multiple, isAllSelected]);
  var isChipsVisible = multiple && showChips;
  var invisibleCountriesCount = isChipsVisible && Array.isArray(value) && value.length > visibleChipsCount ? value.length - visibleChipsCount : 0;
  var countryChips = (0, _react.useMemo)(function () {
    if (!isChipsVisible || !Array.isArray(value)) {
      return [];
    }

    var visibleChips = (0, _ramda.slice)(0, visibleChipsCount, value);
    return visibleChips.map(function (country) {
      return /*#__PURE__*/_react.default.createElement(_material.Chip, {
        classes: {
          root: classes.chipRoot,
          label: classes.chipLabel,
          deleteIcon: classes.chipDeleteIcon,
          clickable: classes.chipClickable
        },
        size: "small",
        label: country.name,
        avatar: /*#__PURE__*/_react.default.createElement(_material.Avatar, {
          alt: "".concat(country.name, " flag"),
          src: country.image
        }),
        deleteIcon: /*#__PURE__*/_react.default.createElement(_Close.default, {
          "data-id": country.id
        }),
        onDelete: disabled ? undefined : handleUnselectCountry,
        key: country.id
      });
    });
  }, [value, visibleChipsCount, classes, isChipsVisible, handleUnselectCountry, disabled]);
  var invisibleCountryNames = (0, _react.useMemo)(function () {
    var visibleChips = Array.isArray(value) ? (0, _ramda.slice)(visibleChipsCount, value.length, value) : [];
    return visibleChips.map(function (country) {
      return country.name;
    }).join(', ');
  }, [value, visibleChipsCount]);
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    width: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start"
  }, /*#__PURE__*/_react.default.createElement(_ui.MultiAutocomplete, (0, _extends2.default)({
    value: value,
    options: options,
    multiple: multiple,
    renderValue: renderValue,
    getOptionLabel: getOptionLabel,
    renderOption: renderOption,
    onChange: onChange,
    disabled: disabled,
    selectAllEnabled: selectAllEnabled,
    listboxProps: {
      maxVisibleRows: 6
    }
  }, autoCompleteProps)), isChipsVisible && /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: classes.chipsContainer
  }, countryChips, invisibleCountriesCount > 0 && /*#__PURE__*/_react.default.createElement(_ui.Tooltip, {
    placement: "top-start",
    title: invisibleCountryNames
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "Subcopy-Regular-Link"
  }, "+", invisibleCountriesCount))));
};

var _default = CountriesPicker;
exports.default = _default;